import { Snackbar, Alert } from "@mui/material";

export function NotifySnackbar({ notify, onClose }) {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={notify.open}
      autoHideDuration={6000}
      onClose={onClose}
    >
      <Alert
        severity={notify.severity}
        onClose={onClose}
        sx={{ width: "100%", whiteSpace: "pre-line" }}
      >
        {notify.message}
      </Alert>
    </Snackbar>
  );
}